import {
  waitTillAvailable,
  getVariation,
  isFeatureEnabled,
} from "@vp/ab-reader";

export const getExperimentVariation = async (experimentKey) => {
  const available = await waitTillAvailable(1000);

  if (available) {
    return getVariation(experimentKey);
  }

  return undefined;
};

export const getFeatureFlagValue = async (featureFlagKey) => {
  const available = await waitTillAvailable(1000);

  if (available) {
    return isFeatureEnabled(featureFlagKey);
  }

  return false;
};
